export default __webpack_public_path__ + "static/media/eye.8e7e265e.svg";